<template>
    <div class="flats-crm-topbar">
        <!-- <flatsBookingCounter class="mobile-counter"></flatsBookingCounter> -->
        <div class="topbar-top-container">
            <div class="filter-link">
                <a href="#" @click.prevent="openFilterWindow">
                    <svgIcon name="filter-mobile" class="icon-filter"/>
                    <span>{{flatsPage.flats_cards_info.flat_btn_filter_btn_mobile}}</span>
                </a>
            </div>
            <div class="btns-cards-view-mobile">
                <div class="btns">
                    <div class="item" :class="{active: isOpenSortFlatsTopBar}">
                        <a href="#" class="btn-change-cards-view" @click.prevent="$store.commit('openSortFlatsTopBar', !isOpenSortFlatsTopBar)">
                            <svgIcon name="sort" class="icon-sort"/>
                        </a>
                    </div>
                    <div class="item" :class="{active: gridView}">
                        <a href="#" class="btn-view-grid btn-change-cards-view" @click.prevent="setGridView(true)">
                            <svgIcon name="grid-items" class="icon-grid"/>
                        </a>
                    </div>
                    <div class="item" :class="{active: !gridView}">
                        <a href="#" class="btn-view-list btn-change-cards-view"@click.prevent="setGridView(false)">
                            <svgIcon name="list-items" class="icon-list"/>
                        </a>
                    </div>
                </div>
            </div>
        </div>

        <div class="filter-short-mobile-items" v-if="isOpenSortFlatsTopBar">
            <span>{{flatsPage.flats_cards_info.sort_filter_title}}</span>
            <div class="select-container rules">
                <div class="select-in">
                    <select v-model="filterDataBase.sortedByDirection" v-if="isMobileChecker" @change="setActiveSortingParam('shorting_rule', $event)">
                        <option v-for="(item, index) in shortingParams.rules" :value="item.param" :key="index">
                            {{item.name}}
                        </option>
                    </select>
                    <div class="drop-icon">
                        <svgIcon name="arrow_drop" class="icon-svg"/>
                    </div>
                </div>
            </div>
            <div class="select-container params">
                <div class="select-in">
                    <select v-model="filterDataBase.sortedByField" v-if="isMobileChecker" @change="setActiveSortingParam('shorting_param', $event)">
                        <option v-for="(item, index) in shortingParams.params" :value="item.param" :key="index">
                            {{item.name}}
                        </option>
                    </select>
                    <div class="drop-icon">
                        <svgIcon name="arrow_drop" class="icon-svg"/>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import svgIcon from '@/components/partials/SvgIcon.vue';
    import flatsBookingCounter from '@/components/flats-crm/flats-crm-book-counter.vue'
    import {mapGetters} from 'vuex'
    export default {
        name: 'sale-CRM-flats-topbar',
        components: {
            svgIcon,
            flatsBookingCounter,
        },
        data () {
            return {
                shortingParams: {
                    params: [
                        {
                            name: 'Комнатности',
                            param: 'ROOM',
                        },
                        {
                            name: 'Стоимости',
                            param: 'PRICE',
                        },
                        {
                            name: 'Этажности',
                            param: 'FLOOR',
                        },
                        {
                            name: 'Площади',
                            param: 'AREA',
                        },
                    ],
                    rules: [
                        {
                            name: 'Убыванию',
                            param: 'DESCENDING',
                        },
                        {
                            name: 'Возрастанию',
                            param: 'ASCENDING',
                        }
                    ]
                },
            }
        },
        computed: mapGetters({
            salesCard: 'loadSalesCardContent',
            salesCardPage: 'loadSalesCardPage',
            flatsPage: 'loadFlatsPage',
            filterVisible: 'loadVisibleFilterMobile',
			gridView: 'loadLandFlatsGridView',
            filterDataBase: 'loadFilterData',
            filterDynamicParams: 'loadFilterDynamicParam',
            isMobileChecker: 'loadIsMobileChecker',
            isOpenSortFlatsTopBar: 'loadOpenSortFlatsTopBar',
        }),
        methods: {
            setGridView(param) { 
				this.$store.commit('gridViewFlatsCardSet', param);
            },
            openFilterWindow() {
                window.body.addClass('overflowTrue');
				document.getElementById('header').classList.add('notvisibleSalesLand');
                document.getElementById('footer').classList.add('notvisibleSalesLand');
				this.$store.commit('SetVisibleFilterMobile', true);
            },
            // изменения полей сортировки о обновление фильтра после изменений в фильтах "сортировка"
            setActiveSortingParam(param, data) {
                console.log(param, data.target.value)
                this.$store.commit('filterDynamicParamsUpdate', { 'param': param, 'data': data.target.value });
                this.updateFilterDataBase();
            },
            updateFilterDataBase() { // Обновляем данные фильтра в хранилище данных
                this.$store.commit('FilterDataUpdate', {type: 'pageNumber', number: 1})
                this.$store.commit('UpdatePaginPageNumber', 1);
                // console.log(this.filterDataBase, 'DATA FILTER STORE')
                setTimeout(() => {
                    this.getItemsFlatsByFilter();
                }, 300);
                // console.log(this.filterData);
            },
            getItemsFlatsByFilter() {
                this.$store.dispatch('getFlatsByFilter', this.filterDataBase);
                this.$store.dispatch('getFlatsPagintationCounters', this.filterDataBase);
            },
        },
        beforeCreate() {
        },
        created () {
        },
        mounted () {
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/flats-crm/respond/flats-crm-topbar.scss';
    // @import '@/styles/components/flats-crm/respond/flats-crm-btns-respond.scss';
    // @import '@/styles/respond/sales/sales-land-partials/land-flats-respond.scss';
    // @import '@/styles/respond/sales/respond-sale-item.scss';
</style>